import { bootstrapApplication } from '@angular/platform-browser';
import { initSentry } from '@vendorhub/shared/analytics';
import { environment } from './environments/environment';
import { appConfig } from './app/app.config';
import { App } from './app/app';

initSentry(environment, 'marketplace');

bootstrapApplication(App, appConfig).catch((err) => console.error(err));
